import React from 'react'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

// import from './../selectors/user.js'
import { fetchingState } from './../helpers/hocs.js'
import { get, send } from '../store/reducers/feedback'

import Form from './../components/Form'
import Select from './../components/Select'
import Loader from './Loader'
import Textarea from 'react-textarea-autosize'
import { setState } from '../store/reducers/auth.js'

// {data.name && <span className='Contacts-form__underhead Text'>{data.name} {data.contact && data.contact} {(data.topic && topics[data.topic]) && topics[data.topic]}</span>}


const ContactsForm = ({ success = null, topics, data = {}, tmpData, setData, peoceed, fetching, submit, intl, isValid }) => {
  //console.log('tmpData', tmpData);
  //console.log('data', data);
  this.state = {
    isValid: ''
  };

  /*function onChange(e) {
    this.setState(
      {textValue : event.target.value}
  );
  }*/
  return (
    <div className='Contacts-form__body'>
      {
        success ? <div className='Contacts-form__title Head'>
          Ваше сообщение отправлено!
      </div>
          : (
            <div>
              <h1 className='Contacts-form__title Head'>
                Хотим менять мир <span className='Contacts-form__title-orange'>вместе</span>!
            </h1>
              <div className='Contacts-form__text'>
                Мы глубоко убеждены, что каждая покупка имеет значение, и что
                у бизнесов прибыль не единственная цель. Присоединяйтесь к
              нам, будем менять мир вместе! {/*{fetching.info}{data.name}*/}
              </div>
              {!fetching.info && (
                <div>
                  <form className='Contacts-form__table' onSubmit={submit}>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>Бренд</div>
                      <input className='Contacts-form__table-subrow'
                        type="text"
                        name="brand"
                        value={tmpData.brand}
                        onChange={setData('brand')}
                      />
                    </div>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>Сайт</div>
                      <input className='Contacts-form__table-subrow'
                        type="text"
                        name="website"
                        value={tmpData.website}
                        onChange={setData('website')}
                      />
                    </div>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>Сфера деятельности</div>
                      <input className='Contacts-form__table-subrow'
                        type="text"
                        name="activity"
                        value={tmpData.activity}
                        onChange={setData('activity')}
                      />
                    </div>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>Ваши пожелания по благотворительным акциям</div>
                      <Textarea className='Contacts-form__table-subrow-message Comments__field'
                        type="text"
                        name="message"
                        value={tmpData.message}
                        onChange={setData('message')}
                      />
                    </div>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>ФИО</div>
                      <input className='Contacts-form__table-subrow'
                        type="text"
                        name="fio"
                        value={tmpData.fio}
                        onChange={setData('fio')}
                      />
                    </div>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>Должность</div>
                      <input className='Contacts-form__table-subrow'
                        type="text"
                        name="position"
                        value={tmpData.position}
                        onChange={setData('position')}
                      />
                    </div>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>Телефон</div>
                      <input className='Contacts-form__table-subrow'
                        type="text"
                        name="phone"
                        value={tmpData.phone}
                        onChange={setData('phone')}
                      />
                    </div>
                    <div className='Contacts-form__table-row'>
                      <div className='Contacts-form__table-subrow'>E-mail</div>
                      <input className='Contacts-form__table-subrow'
                        type="text"
                        name="email"
                        value={tmpData.email}
                        onChange={setData('email')}
                      />
                    </div>
                  </form>
                  <div className='Contacts-form__table-error'>{isValid}</div>
                  <div className=" Contacts-form__button-wrap">
                    <button className='Button Button_black' onClick={ submit }/*onSubmit={submit}*/>
                      Отправить заявку
                    </button>
                  </div>
                  {/*
                  {!data.name && <Form value={tmpData.name} onInput={setData('name')}
                    placeholder="Имя" onSubmit={peoceed.bind(this, 'name')} />}
                  {(data.name && !data.contact) && <Form value={tmpData.contact} onInput={setData('contact')}
                    placeholder="Почта или телефон" onSubmit={peoceed.bind(this, 'contact')} />}
                  {(data.contact && !data.topic) && <Select value={tmpData.topic} items={topics} onSubmit={peoceed.bind(this, 'topic')} />}
                  {(data.topic) && <Form value={tmpData.message} onInput={setData('message')}
                    placeholder="Сообщение" onSubmit={submit} />}
                */}
                </div>
              )}
              
              {(fetching.send || fetching.info) && <Loader isLight />}
              {!isNil(success) && <div className='Text'>
                <FormattedMessage id='contacts_form.error' />
              </div>}
            </div>
          )
      }
    </div>
  )
}

const mapStateToProps = state => {
  //console.log('state', state)
  return ({ ...state.feedback })
}

const mapDispatchToProps = dispatch => bindActionCreators({ get, send }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('data', 'setData', {}),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withState('isValid', 'setIsValid', ''),
  fetchingState({ multi: true }),
  withHandlers({
    get: ({ get, fetchingWrap }) => () => fetchingWrap(get.bind(this), 'info'),
    setData: ({ setTmpData, tmpData }) => field => e => {
      //console.log('tmpData', tmpData)
      //console.log('field', field)
      //console.log('e.target.value', e.target.value)//.replace(/(<([^>]+)>)/ig, '')
      tmpData[field] = e.target.value//e
      setTmpData(tmpData)
    },
    clearData: ({ setData }) => () => {
      setData({})
    },
    peoceed: ({ setData, data, setTmpData, tmpData }) => (field, e) => {
      e && e.preventDefault && e.preventDefault()
      //console.log('data', data)
      data[field] = /*field === 'topic' ? e :*/ tmpData[field]
      setData(data)
      //if (field === 'topic') setTmpData({ ...tmpData, [field]: e })
    },
    submit: ({ send, info, tmpData, data, setSuccess, fetchingWrap, setIsValid }) => async e => {
      e && e.preventDefault()
      if (!tmpData.fio || !tmpData.position || !tmpData.email || !tmpData.phone || !tmpData.brand || !tmpData.activity || !tmpData.website || !tmpData.message){
        //tmpData.isValid = 'Необходимо заполнить все поля'
        setIsValid('Необходимо заполнить все поля')
      } else {
      const name = tmpData.fio + ' (' + tmpData.position + ')'
      const contact = tmpData.email + ', ' + tmpData.phone
      const message = tmpData.brand + ' (' + tmpData.activity+ ', ' + tmpData.website + '): '
       + tmpData.message
      data = { name: name, contact: contact, message: message, topic: 'landing - partners' }
      //console.log('data', data)
      setSuccess(null)
      //data = { ...info, ...tmpData, topic: data.topic }
      const result = await fetchingWrap(send.bind(this, data), 'send')
      setSuccess(result === 200)
      }
    }
  }),
  withProps(props => ({
    data: { /*...props.info, ...props.data*/ },
    tmpData: { /*...props.info, ...props.tmpData*/ }
  })),
  lifecycle({
    componentWillMount() {
      this.props.clearData()
      this.props.setTmpData({brand: '', website: '', activity: '', message: '', fio: '', position: '', phone: '', email: '', isValid: '' })
      this.props.get()
    },
    componentWillUnmount() {
      this.props.setTmpData({})
      this.props.setSuccess(null)
      this.props.clearData()
    }
  })
)(ContactsForm))



// WEBPACK FOOTER //
// ./src/components/ContacsForm.jsx